import React from 'react';
import {observer} from "mobx-react";
import {IonToggle} from "@ionic/react";
import {
    IPassengerTypeMutationDescriptor,
    IPassengerViewModel
} from "../../../../services/booking/models/passenger/passenger-view-model.interface";
import styled from "styled-components";
import {LabelAndIconContainerBox, LabelBox, ToggleContainerBox} from "./boxes/passenger-property-toggle.boxes";


const GridBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    justify-items: center;
    gap: ${props => props.theme.spacing.flexGap24};
    ${props => props.theme.containerMediaQuery.smallScreen} {
        justify-items: flex-start;
        grid-template-columns: 1fr;
    }
    
`

const PassengerTypeToggleContainerBox = styled(ToggleContainerBox)`
    ${props => props.theme.containerMediaQuery.smallScreen} {
        width: 100%;
    }
    
`

interface PassengerTypeToggleComponentProps {
    mutationDescriptor: IPassengerTypeMutationDescriptor;
}
const PassengerTypeToggleComponent: React.FC<PassengerTypeToggleComponentProps> = observer((props) => {
    const togglePassengerType = () => {
        props.mutationDescriptor.toggle();
    }

    return (
        <PassengerTypeToggleContainerBox >
            <LabelAndIconContainerBox onClick={togglePassengerType}>
                <LabelBox>
                    {props.mutationDescriptor.description}
                </LabelBox>
            </LabelAndIconContainerBox>

            <IonToggle checked={props.mutationDescriptor.isSelected}
                       onIonChange={() => togglePassengerType()}/>
        </PassengerTypeToggleContainerBox>
    );


});

interface PassengerTypeSwitcherComponentProps {
    passenger: IPassengerViewModel;
}

export const PassengerTypeSwitcherComponent: React.FC<PassengerTypeSwitcherComponentProps> = observer((props) => {

    const allowedPassengerTypeMutations = props.passenger.allowedPassengerTypeMutations;
    if(allowedPassengerTypeMutations.length === 0) {
        return null;
    }

    return (
        <GridBox>
            {allowedPassengerTypeMutations.map((mutationsDescriptors) => {
                return (
                    <PassengerTypeToggleComponent key={mutationsDescriptors.mainPassengerType}
                                                     mutationDescriptor={mutationsDescriptors}/>
                )
            })}
        </GridBox>
    )
})